// Test IDs for the Profesionales (who attends appointments, with or without
// login) feature. Separate from Equipo (who has login/user accounts).

export const PROFESSIONALS = {
  page: 'professionals-page',
  explainerBanner: 'professionals-explainer-banner',
  addButton: 'professionals-add-button',
  emptyState: 'professionals-empty-state',
  table: 'professionals-table',
  rowPrefix: 'professionals-row-', // + professionalId
  editButtonPrefix: 'professionals-edit-button-', // + professionalId
  archiveButtonPrefix: 'professionals-archive-button-', // + professionalId
  reactivateButtonPrefix: 'professionals-reactivate-button-', // + professionalId
  showArchivedToggle: 'professionals-show-archived-toggle',
  loginBadgePrefix: 'professionals-login-badge-', // + professionalId

  modal: 'professionals-modal',
  modalNameInput: 'professionals-modal-name-input',
  modalPhotoUpload: 'professionals-modal-photo-upload',
  modalSpecialtyInput: 'professionals-modal-specialty-input',
  modalAccessModeSelect: 'professionals-modal-access-mode-select',
  modalLinkUserSelect: 'professionals-modal-link-user-select',
  modalLoginEmailInput: 'professionals-modal-login-email-input',
  modalLoginPasswordInput: 'professionals-modal-login-password-input',
  modalUnlinkButton: 'professionals-modal-unlink-button',
  modalSaveButton: 'professionals-modal-save-button',
  // Fix AZ (2026-10-30): pagina web
  modalShowOnLanding: 'professionals-modal-show-on-landing',
  modalFeaturedDoctor: 'professionals-modal-featured-doctor',
  modalBioInput: 'professionals-modal-bio-input',
  webBadgePrefix: 'professionals-web-badge-', // + professionalId
  modalCancelButton: 'professionals-modal-cancel-button',
};
